
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./CrmManage": () => {
return Promise.all(/*  | __federation_expose_CrmManage */ [__webpack_require__.e("787"), __webpack_require__.e("267"), __webpack_require__.e("130")]).then(() => (() => (__webpack_require__(1709))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };